export const SET_IS_PENDING = 'rpb2b-react/accountview/SET_IS_PENDING';
export type SET_IS_PENDING = typeof SET_IS_PENDING;

export const SET_ERROR = 'rpb2b-react/accountview/SET_ERROR';
export type SET_ERROR = typeof SET_ERROR;

export const SET_MENU_OPTION = 'rpb2b-react/accountview/SET_MENU_OPTION';
export type SET_MENU_OPTION = typeof SET_MENU_OPTION;

export const POWER_USER_SEARCH_RESULTS =
  'rpb2b-react/accountview/POWER_USER_SEARCH_RESULTS';
export type POWER_USER_SEARCH_RESULTS = typeof POWER_USER_SEARCH_RESULTS;

export const DASHBOARD_VIEW_SUCCEED =
  'rpb2b-react/accountview/DASHBOARD_VIEW_SUCCEED';
export type DASHBOARD_VIEW_SUCCEED = typeof DASHBOARD_VIEW_SUCCEED;

export const SET_DASHBOARD_CURRENT_PASSWORD =
  'rpb2b-react/accountview/SET_DASHBOARD_CURRENT_PASSWORD';
export type SET_DASHBOARD_CURRENT_PASSWORD = typeof SET_DASHBOARD_CURRENT_PASSWORD;

export const SET_DASHBOARD_NEW_PASSWORD =
  'rpb2b-react/accountview/SET_DASHBOARD_NEW_PASSWORD';
export type SET_DASHBOARD_NEW_PASSWORD = typeof SET_DASHBOARD_NEW_PASSWORD;

export const SET_DASHBOARD_NEW_PASSWORD_REPEAT =
  'rpb2b-react/accountview/SET_DASHBOARD_NEW_PASSWORD_REPEAT';
export type SET_DASHBOARD_NEW_PASSWORD_REPEAT = typeof SET_DASHBOARD_NEW_PASSWORD_REPEAT;

export const SET_DASHBOARD_NEW_PASSWORD_VALIDATION =
  'rpb2b-react/accountview/SET_DASHBOARD_NEW_PASSWORD_VALIDATION';
export type SET_DASHBOARD_NEW_PASSWORD_VALIDATION = typeof SET_DASHBOARD_NEW_PASSWORD_VALIDATION;

export const ECHECK_DISABLED_USER_SEARCH_RESULTS =
  'rpb2b-react/accountview/ECHECK_DISABLED_USER_SEARCH_RESULTS';
export type ECHECK_DISABLED_USER_SEARCH_RESULTS = typeof ECHECK_DISABLED_USER_SEARCH_RESULTS;

export default {
  SET_IS_PENDING,
  SET_ERROR,
  SET_MENU_OPTION,
  DASHBOARD_VIEW_SUCCEED,
  POWER_USER_SEARCH_RESULTS,
  SET_DASHBOARD_CURRENT_PASSWORD,
  SET_DASHBOARD_NEW_PASSWORD,
  SET_DASHBOARD_NEW_PASSWORD_REPEAT,
  SET_DASHBOARD_NEW_PASSWORD_VALIDATION,
  ECHECK_DISABLED_USER_SEARCH_RESULTS
};
